import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

export const Toggle = ({ handleChange, isChecked }) => {
    return (
        <>
            <FormControlLabel
                sx={{ display: 'block' }}
                control={
                    <Switch
                        type="checkbox"
                        id="check"
                        onChange={handleChange}
                        checked={isChecked}
                        name="Modo Oscuro"
                        color="default"
                    />
                }
                label="Modo Oscuro"
            />
        </>
    );
};